import {helpers} from "vuelidate/lib/validators";

export const customValidators = {
    alpha: helpers.regex('alpha', /^[a-zA-Z_ ]*$/),
    italianPhoneNumber: helpers.regex('italianPhoneNumber', /^(0{1}[1-9]{1,3})(\d{4,7})$/),
    italianMobileNumber: helpers.regex('italianMobileNumber', /^((3[0-9][0-9]))(\d{7})$/),
    italianPostcode: helpers.regex('italianPhoneNumber', /^[0-9]{5}$/)
  };